export function documentIsHidden() {
  return typeof document !== "undefined" && Boolean(document.hidden);
}

export function whenDocumentVisible(callback) {
  if (typeof callback !== "function") return;

  if (!documentIsHidden()) {
    callback();
    return;
  }

  let done = false;
  const finish = () => {
    if (done || documentIsHidden()) return;
    done = true;
    document.removeEventListener("visibilitychange", finish);
    window.removeEventListener("pageshow", finish);
    callback();
  };
  document.addEventListener("visibilitychange", finish);
  window.addEventListener("pageshow", finish);
  if (!documentIsHidden()) finish();
}

export function retryWhileDocumentHidden(task, { maxAttempts = 3 } = {}) {
  let attempts = 0;

  const run = () => {
    attempts += 1;
    return Promise.resolve()
      .then(task)
      .catch((error) => {
        if (attempts >= maxAttempts || !documentIsHidden()) {
          throw error;
        }
        return new Promise((resolve, reject) => {
          whenDocumentVisible(() => {
            run().then(resolve, reject);
          });
        });
      });
  };

  return run();
}
